//Dokumetation https://github.com/jorgegorka/svelte-router

import NoPageFound from './routes/404.svelte';
import ProductContainer from './routes/products/Product_Container.svelte';

import OverViewProduct from './routes/products/Overview_Product.svelte';
import OverViewBuyerPersonas from './routes/products/Overview_BuyerPersonas.svelte';
import OverViewBuyerPersona from './routes/products/Overview_BuyerPersona.svelte';
import OverViewWebsites from './routes/products/Overview_Websites.svelte';

import Create_Product from './routes/products/Create_Product.svelte';
import HtmlEditor from './components/HtmlEditor.svelte';
import LiquidTest from './edit/Liquid_Test.svelte';
import WebsiteEdit from './edit/Website_Edit.svelte';
import Welcome from './components/Welcome.svelte';
import TemplateDemo from './edit/TemplateDemo.svelte';

// const isLoggedIn = await currentUser.subscribe(value => {
//     alert(value);
//     return value != null;
// })

function isLoggedIn() {
  return true; //ToDo how to detect, if user is there instantly
}

const routes = [
  {
    name: '/',
    component: Welcome,
    onlyIf: { guard: isLoggedIn, redirect: '/' }
  },
  {
    name: 'product/:id',
    component: ProductContainer,//OverViewProduct,
    onlyIf: { guard: isLoggedIn, redirect: '/' },
    nestedRoutes: [
      { name: 'company', component: NoPageFound },
      { name: 'product-details', component: OverViewProduct },
      { name: 'buyer-personas', component: OverViewBuyerPersonas},
      { name: 'buyer-personas/persona/:buyerPersonaId', component: OverViewBuyerPersona },
      { name: 'competitors', component: NoPageFound },
      { name: 'websites', component: OverViewWebsites },
      { name: 'landing-pages', component: NoPageFound },
      { name: 'sucess-stories', component: NoPageFound },
      { name: 'presentation', component: NoPageFound },
      { name: 'launches', component: NoPageFound },
      // { name: 'benefits', component: OverViewBenefits },
      { name: 'email-series', component: NoPageFound },
      { name: 'edit/website/:websiteId', component: WebsiteEdit }
    ]
  },
  {
    name: 'products',
    component: OverViewProduct,
    onlyIf: { guard: isLoggedIn, redirect: '/' }
  },
  {
    name: 'editorPrototype',
    component: HtmlEditor,
    onlyIf: { guard: isLoggedIn, redirect: '/' }
  },
  // { name: 'login', component: Login },
  { name: 'createProduct', component: Create_Product },
  { name: 'editWebsite', component: WebsiteEdit },

  { name: 'liquidTest', component: LiquidTest },
  { name: 'templateDemo', component: TemplateDemo },
  { name: '404.html', component: NoPageFound }

  //   {
  //     name: 'admin',
  //     component: AdminLayout,
  //     onlyIf: { guard: isLoggedIn, redirect: '/login' },
  //     nestedRoutes: [
  //       { name: 'index', component: AdminIndex },
  //       {
  //         name: 'employees',
  //         component: '',
  //         nestedRoutes: [
  //           { name: 'index', component: EmployeesIndex },
  //           { name: 'show/:id', component: EmployeesShow }
  //         ]
  //       }
  //     ]
  //   }
]

export { routes }